import { memo } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Link from 'components/Link';
import cleanObject from 'utils/clean-object';
import styles from './CategoryFilterList.module.scss';

function RangeFilters({
  closeoutText,
  facet,
  filterParam,
  isListExpanded,
  limitToShow = 10,
  path,
  promotion,
  ranges,
}) {
  const router = useRouter();
  return (
    <>
      {ranges.map(({ term, from, to }, index) => {
        const facetText = term
          ? closeoutText
          : `$${from / 100}${to ? `-${to / 100}` : '+'}`;
        const facetValue = term || `${from} to ${to || '*'}`;
        const paramValue = encodeURIComponent(`${facet}^range^${facetValue}`);
        const isAlreadySelected = filterParam.split(',').includes(paramValue);
        const filterQueryParam = filterParam
          ? isAlreadySelected
            ? filterParam.replace(paramValue, '')
            : `${filterParam},${paramValue}`
          : paramValue;

        return (
          <li
            key={facetText}
            className={classNames({
              [styles.hide_option]: index >= limitToShow && !isListExpanded,
            })}
            data-value="filter"
          >
            <Link
              shallow
              href={{
                pathname: path,
                query: cleanObject({
                  sort: router.query.sort,
                  promotion,
                  filters: filterQueryParam,
                  search: router.query.search,
                }),
              }}
              className={classNames(styles.filter_link, {
                [styles.filter_selected]: isAlreadySelected,
              })}
            >
              {facetText}
            </Link>
          </li>
        );
      })}
    </>
  );
}

export default memo(RangeFilters);
